module.exports = __webpack_public_path__ + "static/media/reseller.8dca9083.svg";